import { render, staticRenderFns } from "./PaginationBar.vue?vue&type=template&id=7affd521&"
import script from "./PaginationBar.vue?vue&type=script&lang=js&"
export * from "./PaginationBar.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/cjzhi98/chatwoot-saas/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('7affd521')) {
      api.createRecord('7affd521', component.options)
    } else {
      api.reload('7affd521', component.options)
    }
    module.hot.accept("./PaginationBar.vue?vue&type=template&id=7affd521&", function () {
      api.rerender('7affd521', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "app/javascript/dashboard/components/dahreply/PaginationBar.vue"
export default component.exports